import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RJ, TITLE_FONT } from '../../rapport/rapportTokens';

// Shared section header for the post-intervention hub (§5) — a brand-system
// icon + an AronVF title. Page-scoped charte (RJ + TITLE_FONT) reused from the
// visit-report epic; nothing leaks to the global theme / header / footer.
const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;

  & svg {
    flex-shrink: 0;
  }
`;

const Title = styled.h2`
  margin: 0;
  font-family: ${TITLE_FONT};
  font-weight: 900;
  font-size: 20px;
  line-height: 1.2;
  color: ${RJ.text};
`;

const CourseSectionHeading = ({ icon, children, ...rest }) => (
  <Wrap {...rest}>
    {icon}
    <Title>{children}</Title>
  </Wrap>
);

CourseSectionHeading.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node.isRequired,
};

CourseSectionHeading.defaultProps = {
  icon: null,
};

export default CourseSectionHeading;
